import React from 'react';
import { mutateImageUrl } from '../../../wordpress';
import TorsoTextOverlay from '../TorsoTextOverlay';

const ProductImageView = ({
    defaultImage,
    attr,
    torsoOverlayImages,
    activeSection,
    currentProductId,
    selectedProducts,
    backImageSrc,
    showBackImage,
    torsoTextState,
    productTags,
    product,
    variations,
}) => {
    let imgSrc = '';
    if (showBackImage && backImageSrc) {
        imgSrc = backImageSrc;
    } else if (attr?.image?.url) {
        imgSrc = attr.image.url;
    } else {
        imgSrc = defaultImage.url;
    }
    const attributeIsSelected = !(Array.isArray(attr) && attr.length === 0) || variations.length === 1;
    const isViewingSelectedProduct = selectedProducts.bodies?.product?.id === currentProductId;
    let showOverlayText = false;
    if (
        ((selectedProducts.bodies && isViewingSelectedProduct) || !selectedProducts.bodies) &&
        (attributeIsSelected || showBackImage)
    ) {
        showOverlayText = true;
    }

    return (
        <div className="product-media product-image-view">
            <img className="base-image" src={mutateImageUrl(imgSrc, 480, 480)} />
            {activeSection === 'bodies' && (
                <>
                    {torsoOverlayImages && !showBackImage && (
                        <img
                            className="image-overlay overlay-torso--chest"
                            src={torsoOverlayImages.torsoOverlayImage}
                        />
                    )}

                    {torsoOverlayImages && !showBackImage && (
                        <img className="image-overlay overlay-torso--hands" src={torsoOverlayImages.handImage} />
                    )}

                    {showOverlayText && (
                        <TorsoTextOverlay
                            showBackImage={showBackImage}
                            torsoTextState={torsoTextState}
                            currentlySelectedAttributes={attr?.id ? attr : null}
                            productTags={productTags}
                            product={product}
                        />
                    )}
                </>
            )}
        </div>
    );
};

export default ProductImageView;
